import { useState } from "react";
import { toast } from "sonner";
import { streamPost } from "@/lib/stream";
import { useApi } from "./useApi";

export const useNames = () => {
  const { data } = useApi("/atletas");
  const map = Object.fromEntries((data || []).map((a) => [a.id, a.nombre]));
  return (txt) => txt.replace(/Atleta (AT\d+)/g, (m, id) => (map[id] ? `${map[id]} (${id})` : m));
};

const SECS = [["interpretacion", /interpretaci[oó]n/i], ["fortalezas", /fortalezas/i], ["factores", /factores/i], ["objetivo", /objetivo/i], ["plan", /plan/i]];

export const parseDraft = (txt) => {
  const out = {};
  txt.split(/^###\s*/m).forEach((block) => {
    const [head, ...rest] = block.split("\n");
    const s = SECS.find(([, rx]) => rx.test(head || ""));
    if (s && !out[s[0]]) out[s[0]] = rest.join("\n").trim();
  });
  return out;
};

export const useStream = () => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (path, body) => {
    setText(""); setBusy(true);
    let acc = "";
    try {
      const meta = await streamPost(path, body, (t) => { acc += t; setText(acc); });
      return { text: acc, ...meta };
    } catch (e) { toast.error(e.message); return null; }
    finally { setBusy(false); }
  };
  return { text, busy, run, setText };
};

export const IABorrador = ({ registroId, atletaId, onUse }) => {
  const { text, busy, run } = useStream();
  const names = useNames();
  return (
    <div className="panel noprint" style={{ marginTop: 12, border: "1px solid #1E4F87" }} data-testid="ia-borrador">
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <b>Borrador con IA</b>
        <button type="button" className="chip" style={{ background: "var(--sol)", color: "var(--ink)" }} disabled={busy} onClick={() => run("/ia/borrador", { registroId, atletaId })} data-testid="ia-borrador-btn">{busy ? "Generando…" : text ? "Generar de nuevo" : "Generar borrador"}</button>
        {onUse && text && !busy && <button type="button" className="chip" onClick={() => onUse(parseDraft(names(text)))} data-testid="ia-borrador-usar-btn">Usar en el formulario</button>}
      </div>
      <p className="note" style={{ margin: "6px 0 0" }}>Claude solo recibe las puntuaciones, el deporte y la edad, sin el nombre. Es un borrador: revísalo y ajústalo con tu criterio profesional.</p>
      {text && <p className="pre" style={{ marginTop: 10 }} data-testid="ia-borrador-text">{names(text)}</p>}
    </div>
  );
};

export const IAPanel = ({ F }) => {
  const { text, busy, run } = useStream();
  return (
    <div className="panel" style={{ border: "1px solid #1E4F87" }} data-testid="ia-panel">
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
        <b>Análisis del panel con IA</b>
        <button className="chip" style={{ background: "var(--sol)", color: "var(--ink)" }} disabled={busy} onClick={() => run("/ia/panel", F)} data-testid="ia-panel-btn">{busy ? "Analizando…" : "Analizar con IA"}</button>
        <span className="note">{F.deporte || "Todos los deportes"} · {F.periodo || "todos los periodos"}</span>
      </div>
      {text && <p className="pre" style={{ marginTop: 10 }} data-testid="ia-panel-text">{text.replace(/^###\s*/gm, "")}</p>}
    </div>
  );
};
